/**
 * Repay payment API endpoints (MR Rupya).
 * Hash / merchant keys must stay on backend only.
 */
const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  process.env.REACT_APP_TASK_API_ORIGIN ||
  'https://mrrupya.in';

const joinUrl = (path) => `${API_ORIGIN.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;

/** POST form-urlencoded → { status, payu_url, params, message? } */
export const payUHashUrl = () =>
  process.env.REACT_APP_PAYU_HASH_URL || joinUrl('payu/generatePayUHash');

/** Optional — enable when backend confirms Paytm for MR Rupya */
export const paytmInitiateUrl = () =>
  process.env.REACT_APP_PAYTM_INITIATE_URL || joinUrl('paytm/initiate');

export const customerHistoryUrl = (query) =>
  `${API_ORIGIN.replace(/\/$/, '')}/Api/TaskApi/oldUserHistory?pancard=${encodeURIComponent(query)}`;

/** Amount charged at gateway — prefer outstanding (pending) balance */
export const getRepayChargeAmount = (customer) => {
  const outstanding = Number(customer?.outstandingAmount);
  if (Number.isFinite(outstanding) && outstanding > 0) return outstanding;

  const tillDate = Number(customer?.tillDateRepayAmount);
  if (Number.isFinite(tillDate) && tillDate > 0) return tillDate;

  const total = Number(customer?.repayAmount);
  if (Number.isFinite(total) && total > 0) return total;

  return 0;
};

/**
 * Payment return page crypto (same scheme as other verticals).
 * Backend encrypts respcode/response; frontend decrypts for display.
 */
export const PAYMENT_AES_KEY = 'LxQY43Nc&87x8nxw';
export const PAYMENT_AES_IV = '@@@@&&&&####$$$$';
